import script from "./ShortcutGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutGuide.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutGuide.vue?vue&type=style&index=0&id=bbd223ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbd223ce"]])

export default __exports__